"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anyWith = exports.any = void 0;

var _pipe = require("../pipe/pipe");

var _isMatch = require("../is-match/is-match");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _any = function _any(_fn, _source) {
  var source = Array.isArray(_source) ? _source : [_source];
  var fn = Array.isArray(_fn) ? _pipe.pipe.apply(void 0, _toConsumableArray(_fn)) : _fn;
  var shouldCompare = typeof fn !== "function";

  for (var i = 0, length = source.length; i < length; i++) {
    if (shouldCompare ? fn === source[i] : fn(source[i]) === true) {
      return true;
    }
  }

  return false;
};
/**
 * Test if at least one element in array matches predicate
 *
 * @param {Fn|Fn[]} fn     Predicate function
 * @param {Array}   source Source array to iterate over
 *
 * @return {Boolean} True if at least one element passes, otherwise false
 *
 * @name any
 * @alias has
 * @tag Array
 * @signature (fn: Function|Function[]) => (source: Array): Boolean
 * @signature (fn: Function|Function[], source: Array): Boolean
 *
 * @see {@link anyWith}
 * @see {@link all}
 * @see {@link allWith}
 *
 * @example
 * any(isNumber)([1, "string", NaN])
 * // => true
 *
 * any([get("id"), is], [{title: ""}, {}])
 * // => false
 */


var any = function any() {
  for (var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++) {
    params[_key] = arguments[_key];
  }

  // @signature (fn) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _any(params[0], source);
    };
  } // @signature (fn, source)


  return _any.apply(void 0, params);
};
/**
 * Test if at least one element in array matches object
 *
 * @param {Object} subset Match object
 * @param {Array}  source Source array to iterate over
 *
 * @return {Boolean} True if at least one element pass, otherwise false
 *
 * @name anyWith
 * @alias hasWith
 * @tag Array
 * @signature (subset: Object) => (source: Array): Boolean
 * @signature (subset: Object, source: Array): Boolean
 *
 * @see {@link any}
 * @see {@link all}
 * @see {@link allWith}
 * @see {@link isMatch}
 *
 * @example
 * anyWith({ comments: is })([{id: 1}, {id: 2, comments: []}])
 * // => true
 *
 * anyWith({ tags: is })([{id: 1}, {id: 2, comments: []}])
 * // => false
 */


exports.any = any;

var anyWith = function anyWith() {
  for (var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    params[_key2] = arguments[_key2];
  }

  // @signature (subset) => (source)
  if (params.length <= 1) {
    return function (source) {
      return _any((0, _isMatch.isMatch)(params[0]), source);
    };
  } // @signature (subset, source)


  return _any((0, _isMatch.isMatch)(params[0]), params[1]);
};

exports.anyWith = anyWith;